import CodeView from "./code";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";

function __generateRandomReference__() {
  const [firstPart, secondPart] = String(Math.random() * 1e7).split('.');
  return String().concat(Date.now(), firstPart.substr(-3), secondPart.substr(0, 3));
}

export default function view() {
  const $this = this;
  const { $charge, $inputs, $timer } = this;

  const __charge__ = accountbank => {
    $timer && $timer.clear();

    $charge.init({
      data: {
        accountbank,
        accountnumber: '00000',
        orderRef: __generateRandomReference__()
      }
    });
  }

  let previousBank;

  return (view = ViewFactory({
    NAME: 'USSD_INIT_VIEW',
    inputs: ['bank'],
    constants: {
      hasBackAction: false,
      instruction: 'Please choose your bank to begin payment'
    },
    next() {
      const bank = getValueAtPath($inputs, '[bank].value.code');

      if (bank) {
        previousBank === bank && $this.USSD_CODE
          ? CodeView && CodeView.activate()
          : __charge__(previousBank = bank);
      }
    }
  }).call(this));
}
